import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';
import * as GUI from 'babylonjs-gui';

class Text extends BasicComponent {
    getType() { return "Text"; }

    constructor( { id } = {} ) {
        super( { id });

        this.open = false;
    }

    construct( context, prefab ) {
        let self = this;
        
        let displayPreviewText = prefab.getPreviewText() ? prefab.getPreviewText().length > 0: false;

        let width = 15 * prefab.getScale();
        let height =  15 * prefab.getScale();

        const base = super.construct( context, prefab ).getRootNode();
        base.position = prefab.getPosition();
        let cameraX =  window.scene.getCameraByName("MainCamera");
        let posCamera = cameraX.position;
        base.lookAt(posCamera);
        
        let textGUI = BABYLON.MeshBuilder.CreatePlane("", { 
            width: 180,
            height: 180,
            sideOrientation: BABYLON.Mesh.DOUBLESIDE 
        }, window.scene);

        textGUI.parent = base;
        textGUI.isPickable = false;
        textGUI.renderingGroupId = 1;
        textGUI.rotation.y = Math.PI;
        textGUI.position.y = -90-7*prefab.getScale();
        textGUI.renderingGroupId = 3;
        textGUI.isPickable = false;

        // GUI
        var advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(textGUI);	

        // Rectangle
        var rect = new GUI.Rectangle();
        rect.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        rect.adaptWidthToChildren = true;
        rect.adaptHeightToChildren = true;
        rect.cornerRadius = 20;
        rect.background = "transparent";
        rect.color = "transparent";
        // rect.alpha = 0.9;
        rect.width = "23%";
        if(prefab.displayedText == "Text-Praxis")
            rect.width = "25%";
        advancedTexture.addControl(rect);

        // Text ontop of Rectanble
        var text = new GUI.TextBlock();
        text.text = context.$i18n.t(prefab.displayedText);
        window.addEventListener("languageChange", () => {
            text.text = context.$i18n.t(prefab.displayedText);
        });
        text.fontSize = prefab.displayedText.length > 20 ? "13pt" : "20pt";
        text.color = prefab.displayedText.length > 20 ? "#525252" : "black";
        text.lineSpacing = 2;
        text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        text.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        text.textWrapping = GUI.TextWrapping.WordWrap;
        text.resizeToFit = true;
        text.paddingTop = 20;
        text.paddingLeft = 20;
        text.paddingRight = 20;
        text.paddingBottom = 20;
        rect.addControl(text);

        if(prefab.displayOnClick == "true"){

            let previewTextGui;
            if(displayPreviewText){
                previewTextGui = BABYLON.MeshBuilder.CreatePlane("", { 
                    width: 180,
                    height: 180,
                    sideOrientation: BABYLON.Mesh.DOUBLESIDE 
                }, window.scene);

                previewTextGui.parent = base;
                previewTextGui.isPickable = false;
                previewTextGui.renderingGroupId = 1;
                previewTextGui.position.y = 5 + 5*prefab.getScale();
                previewTextGui.rotation.y = Math.PI;
                previewTextGui.visibility = 0;
        
                var advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(previewTextGui);
                
                var text = new GUI.TextBlock();
                text.text = prefab.getPreviewText();
                text.fontSize = "35pt";
                text.color = "White";
                text.lineSpacing = 2;
                text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
                text.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
                text.resizeToFit = true;
                advancedTexture.addControl(text);
            }

            textGUI.visibility = 0;

            //Button - OnHover Open Text
            let button = BABYLON.MeshBuilder.CreatePlane("", { 
                width: width,
                height: height,
                sideOrientation: BABYLON.Mesh.DOUBLESIDE 
            }, window.scene);
            
            let icon = MediaManager.getMedia(prefab.getIconID());

            let buttonMaterial = new BABYLON.StandardMaterial("", window.scene);
            buttonMaterial.opacityTexture = buttonMaterial.emissiveTexture =  icon.getTexture();
            buttonMaterial.disableLighting = true;  
            button.material = buttonMaterial;
           
            button.parent = base;
            button.rotation.y = Math.PI;
            button.rotation.z = Math.PI;
            button.renderingGroupId = 2;

            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            
            button.actionManager = new BABYLON.ActionManager(window.scene);
            button.actionManager.hoverCursor = "pointer";
            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function(){     
                self.open = !self.open;
                if(self.open){
                    BABYLON.Animation.CreateAndStartAnimation("", textGUI, "visibility", 30,10, 0, 1, 0, ease);
                }else{
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One(), 0, ease);
                    BABYLON.Animation.CreateAndStartAnimation("", textGUI, "visibility", 30,10, 1, 0, 0, ease);
                }
                    
                window.dispatchEvent(new CustomEvent("closeAllTextElements",{detail:{this: self}}));
            }));

            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function(){     
                if(!self.open){
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One(), 0, ease);
                    if(displayPreviewText)
                        BABYLON.Animation.CreateAndStartAnimation("", previewTextGui, "visibility", 30,10, previewTextGui.visibility, 0, 0, ease);
                }
                    
            }));

            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function(){
                if(!self.open){
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, new BABYLON.Vector3.One(), new BABYLON.Vector3.One().scale(1.2), 0,ease);
                    if(displayPreviewText)
                        BABYLON.Animation.CreateAndStartAnimation("", previewTextGui, "visibility", 30,10, previewTextGui.visibility, 1, 0, ease);
                }
                             
            }));

            window.addEventListener('closeAllTextElements',(e) =>{
                if(e.detail.this != this){
                    self.open = false;
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One(), 0, ease);
                    BABYLON.Animation.CreateAndStartAnimation("", textGUI, "visibility", 30,10, textGUI.visibility, 0, 0, ease);
                    if(previewTextGui)
                        BABYLON.Animation.CreateAndStartAnimation("", previewTextGui, "visibility", 30,10, previewTextGui.visibility, 0, 0, ease);
                }
            });
        }

        return base;
    }
}

export default Text;

